import React, {Component} from "react";
import {Alert, Button, Card, CardBody, CardHeader, Col, Container, Form, FormInput, Row} from "shards-react";

import {connect} from "react-redux";
import {simulations} from "../actions";

/**
 * Componente que permite actualizar datos a partir de un archivo.
 * @class
 * @extends Component
*/
class UpdateDataFromFile extends Component {
/**
 * Crea una instancia de UpdateDataFromFile.
 * @constructor
 * @param {object} props - Propiedades del componente.
*/
    constructor(props) {
        super(props);
        this.state = {
            'file': "",
            inputKey: 0,
        };
        this.successTimer = null;
        this.errorTimer = null;
    }

/**
 * Limpia el estado de file.
 * @function
*/
    clear_all = () => {
        this.setState({
            file: "",
            inputKey: this.state.inputKey + 1,
        })
    };

/**
 * Limpia todos los timers activos.
 * @function
*/
    clearTimers = () => {
        if (this.successTimer) {
            clearTimeout(this.successTimer);
            this.successTimer = null;
        }
        if (this.errorTimer) {
            clearTimeout(this.errorTimer);
            this.errorTimer = null;
        }
    };

/**
 * Inicia el timer para ocultar la alerta de éxito.
 * @function
*/
    startSuccessTimer = () => {
        this.clearTimers();
        this.successTimer = setTimeout(() => {
            this.props.hideSuccessAlert();
        }, 8000);
    };

/**
 * Inicia el timer para ocultar la alerta de error.
 * @function
*/
    startErrorTimer = () => {
        this.clearTimers();
        this.errorTimer = setTimeout(() => {
            this.props.hideErrorAlert();
        }, 8000);
    };

/**
 * Método del ciclo de vida que se ejecuta cuando las props cambian.
 * @function
 * @param {object} prevProps - Props anteriores del componente.
 */
    componentDidUpdate(prevProps) {
        // Iniciar timer para alerta de éxito
        if (this.props.show_success_alert && !prevProps.show_success_alert) {
            this.startSuccessTimer();
        }
        
        // Iniciar timer para alerta de error
        if (this.props.show_error_alert && !prevProps.show_error_alert) {
            this.startErrorTimer();
        }
    }

/**
 * Método del ciclo de vida que se ejecuta cuando el componente se desmonta.
 * @function
 */
    componentWillUnmount() {
        this.clearTimers();
    }

/**
 * Manejador de eventos que actualiza el estado de file con el archivo seleccionado.
 * @function
 * @param {object} e - Evento del cambio de archivo.
*/
    fileChangeHandler = (e) => {
        this.setState({
            file: e.target.files[0],
        })
    };
/**
 * Manejador de eventos que envía el archivo al servidor y luego limpia el estado de file.
 * @function
 * @param {object} e - Evento del envío del formulario.
*/
    submit_file = (e) => {
        e.preventDefault();
        // Limpiar errores previos antes de enviar
        this.props.clearUploadError();
        this.props.update_from_file(this.state).then(() => {
            this.clear_all();
        }).catch(() => {
            // El error ya se maneja en Redux, solo necesitamos evitar que se limpie el formulario
        });
    };
/**
 * Renderiza el componente UpdateDataFromFile.
 * @function
 * @returns {JSX.Element} - Componente React que renderiza el formulario para subir el archivo.
*/
    render() {
        return <Container fluid className="main-content-container px-4">
            {this.props.show_success_alert && <Alert className="mb-0" theme="success">
                Datos actualizados exitosamente
            </Alert>}
            
            {this.props.show_error_alert && <Alert className="mb-0" theme="danger">
                <strong>Error:</strong> {this.props.upload_error?.errors || this.props.upload_error?.message || 'Ocurrió un error al procesar el archivo'}
            </Alert>}

            <Row>
                <Col lg="12" className="mb-8 my-4">
                    <Card small className="">
                        <CardHeader className="border-bottom">
                            <i className="icon icon-altacliente header-icon"/>
                            {/*<h6 className="m-0"></h6>*/}
                        </CardHeader>
                        <CardBody className="d-flex flex-column">
                            <Form onSubmit={this.submit_file}>
                                <Row>
                                    <Col lg="12" className="form-group">
                                        <label>Archivo</label>
                                        <FormInput
                                            key={this.state.inputKey}
                                            type="file"
                                            onChange={this.fileChangeHandler}
                                            required
                                        />
                                    </Col>
                                    <Col lg="12" className="my-4">
                                        <Button 
                                            type="submit" 
                                            className="col-lg-12" 
                                            disabled={this.props.is_uploading}
                                        >
                                            {this.props.is_uploading ? 'Cargando...' : 'Agregar Archivo'}
                                        </Button>
                                    </Col>
                                </Row>
                            </Form>
                        </CardBody>
                    </Card>
                </Col>


            </Row>

        </Container>;

    }

}
/**
 * Función que mapea el estado a las props del componente
 * @param {Object} state - Estado actual de la aplicación
 * @returns {Object} - Objeto que contiene las props mapeadas al estado
*/
const mapStateToProps = state => {
    return {
        customer: state.customersV2.detail,
        updated: state.simulations.data_updated,
        is_uploading: state.simulations.is_uploading,
        upload_error: state.simulations.upload_error,
        show_success_alert: state.simulations.show_success_alert,
        show_error_alert: state.simulations.show_error_alert,
    }
};
/**
 * Función que mapea las acciones a las props del componente
 * @param {Function} dispatch - Función de redux para despachar acciones
 * @returns {Object} - Objeto que contiene las props mapeadas a las acciones
*/
const mapDispatchToProps = dispatch => {
    return {
        update_from_file: (data) => {
            return dispatch(simulations.update_from_file(data))
        },
        clearUploadError: () => {
            return dispatch(simulations.clearUploadError())
        },
        hideSuccessAlert: () => {
            return dispatch(simulations.hideSuccessAlert())
        },
        hideErrorAlert: () => {
            return dispatch(simulations.hideErrorAlert())
        },
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(UpdateDataFromFile);
